export const routeMessages = {
  'route.addresses': '收货地址',
  'route.adminHome': '后台首页',
  'route.cart': '购物车',
  'route.categoryList': '分类管理',
  'route.checkout': '确认订单',
  'route.compare': '商品比较',
  'route.dashboard': '仪表盘',
  'route.favorites': '我的收藏',
  'route.forgotPassword': '重置密码',
  'route.home': '首页',
  'route.inventoryList': '库存列表',
  'route.inventoryWarning': '库存预警',
  'route.login': '登录',
  'route.messageList': '消息中心',
  'route.notFound': '页面未找到',
  'route.notifications': '消息通知',
  'route.orderDetail': '订单详情',
  'route.orderList': '订单列表',
  'route.orderSuccess': '下单成功',
  'route.productCreate': '新增商品',
  'route.productDetail': '商品详情',
  'route.productEdit': '编辑商品',
  'route.productList': '商品列表',
  'route.search': '搜索',
  'route.products': '商品列表',
  'route.profile': '个人中心',
  'route.register': '注册',
  'route.roleList': '角色管理',
  'route.shopDetail': '店铺主页',
  'route.shopList': '店铺管理',
  'route.userCenter': '用户中心',
  'route.userList': '用户管理',
  'route.userOrderDetail': '订单详情',
  'route.userOrders': '我的订单',
};
